import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

const workflowController = new WorkFlowController();

export const fetchCopValuesRequested: Action = createAction(
  ActionTypes.FETCH_COP_VALUES_REQUESTED
);
export const fetchCopValuesReceived: Action = createAction(
  ActionTypes.FETCH_COP_VALUES_RECEIVED
);
export const fetchCopValuesFailed: Action = createAction(
  ActionTypes.FETCH_COP_VALUES_FAILED
);

const fetchAllCopValuesAPI = (order, options) => workflowController.findByFilter("copValues", { order }, options);
export const fetchAllCopValues = (order = "model ASC") => async (dispatch, getState) => {
  dispatch(fetchCopValuesRequested());
  try {
    const btuMeters = await fetchAllCopValuesAPI(order, { token: userAccessTokenSelector(getState()) });
    dispatch(fetchCopValuesReceived(btuMeters));
  } catch (err) {
    dispatch(fetchCopValuesFailed(err));
  }
};

export const setCopValuesRequested: Action = createAction(
  ActionTypes.SET_COP_VALUES_REQUESTED
);
export const setCopValuesReceived: Action = createAction(
  ActionTypes.SET_COP_VALUES_RECEIVED
);
export const setCopValuesFailed: Action = createAction(
  ActionTypes.SET_COP_VALUES_FAILED
);

const setCopValuesAPI = (data, options) =>
  workflowController.execute("cop", null, "setValuesForModel", data, options);
export const setCopValues = data => async (dispatch, getState) => {
  dispatch(setCopValuesRequested(data));
  try {
    await setCopValuesAPI(data, { token: userAccessTokenSelector(getState()) });
    dispatch(setCopValuesReceived(data));
  } catch (err) {
    dispatch(setCopValuesFailed(err));
  }
};

export const bulkSetCopValuesRequested: Action = createAction(
  ActionTypes.BULK_SET_COP_VALUES_REQUESTED
);
export const bulkSetCopValuesReceived: Action = createAction(
  ActionTypes.BULK_SET_COP_VALUES_RECEIVED
);
export const bulkSetCopValuesFailed: Action = createAction(
  ActionTypes.BULK_SET_COP_VALUES_FAILED
);

const bulkSetCopValuesAPI = (data, options) =>
  workflowController.execute("cop", null, "bulkSet", data, options);
export const bulkSetCopValues = fileObj => async (dispatch, getState) => {
  dispatch(bulkSetCopValuesRequested());
  try {
    const data = { content: await fileObj.text() };
    await bulkSetCopValuesAPI(data, { token: userAccessTokenSelector(getState()) });
    dispatch(bulkSetCopValuesReceived(data));
  } catch (err) {
    dispatch(bulkSetCopValuesFailed(err));
  }
};



// WEBPACK FOOTER //
// ./src/features/cop/store/copActions.js